import OLpGlobalHeader from './index.vue';

OLpGlobalHeader.install = app => {
  app.component(OLpGlobalHeader.name, OLpGlobalHeader);
};

export default OLpGlobalHeader;
